import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { FormGroup, ControlLabel } from 'react-bootstrap'

import { GlgSelect } from 'SharedComponents'
import { mapToSelectArray } from 'Shared/helpers'

const CategoryFilterSimGolf = ({ value, onChange, categoriesOptions, disabled }) => {
  const categoriesSelectOptions = mapToSelectArray(categoriesOptions, { changeNone: false })
  const categoryText = (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.category_filter.category'))

  const handleChange = (value) => {
    onChange('category', value)
  }

  return (
    <FormGroup>
      <Row>
        <Col xs={ true }>
          <ControlLabel className='filter_label' id='filter_label'>
            { categoryText }
          </ControlLabel>
        </Col>
      </Row>
      <Row>
        <Col xs={ true } >
          <GlgSelect
            items={ categoriesSelectOptions }
            value={ value }
            onChange={ handleChange }
            disabled={ disabled }
          />
        </Col>
      </Row>
    </FormGroup>
  )
}

CategoryFilterSimGolf.propTypes = {
  categoriesOptions: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default CategoryFilterSimGolf